import { type BatchData } from 'prove-common'
import { RJSFSchema } from 'prove-common/rjsf'

export interface MoveSampleFormData {
  productId?: string
  matrixId?: string
  substanceIds: string[]
}

export const getMoveSampleSchema = (batchData: BatchData): RJSFSchema => {
  const matrices = batchData.matrices
  const products = batchData.products
  const substances = batchData.substances
  return {
    type: 'object',
    properties: {
      productId: {
        type: 'string',
        title: 'Velg produkt',
        description: 'Velg produktet prøven skal tas av',
        oneOf: products.map((product) => {
          return {
            const: product.id.toString(),
            title: product.name
          }
        })
      },
      matrixId: {
        type: 'string',
        title: 'Velg prøve av',
        description: 'Velg matrisen prøven skal tas av',
        oneOf: matrices.map((matrix) => {
          return {
            const: matrix.id.toString(),
            title: matrix.name
          }
        })
      },
      substanceIds: {
        type: 'array',
        title: 'Analyser for',
        description: 'Velg hva det skal analyseres for',
        default: [],
        minItems: 1,
        uniqueItems: true,
        items: {
          type: 'string',
          default: '',
          oneOf: substances.map((substance) => {
            return {
              const: substance.id.toString(),
              title: substance.name
            }
          })
        }
      }
    },
    required: ['productId', 'matrixId', 'substanceIds']
  }
}
